export default __webpack_public_path__ + "static/media/favicon.efdaef15.ico";